import Data1 from "./data1";
import Data2 from "./data2";

export default [Data1, Data2]